import { useSSRData } from 'hooks';
import { getMasslandingData } from 'utils';
import getFirstCorrectData from './utils';

const useMassLandingData = () => {
    const state = useSSRData();
    return getFirstCorrectData(state.masslandingData, getMasslandingData(), []);
};

export default useMassLandingData;
